module.exports = __webpack_public_path__ + "img/ico_documents.8f730076.svg";